import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: 'input',
  standalone: false
})
export class DisableAutocompleteDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', 'off');
  }
}
